import { Inventario, PartilhaResultado, PessoaInventario } from '../types';

export function buildFamilyMapFromInventario(
  inventario: Inventario,
): Map<string, PessoaInventario> {
  const map = new Map<string, PessoaInventario>();
  const all = [inventario.decujus, ...(inventario.familiares || [])].filter(
    (p): p is PessoaInventario => p != null && p.id != null,
  );
  all.forEach((p) => {
    const key = p.id?.toString();
    if (key) map.set(key, p);
  });
  return map;
}

/** Herdeiro/meeiro cadastrado como falecido (ex.: pré-morto com quota repassada por representação). */
export function isPartilhaHerdeiroFalecido(
  p: PartilhaResultado,
  familyMap: Map<string, PessoaInventario> | undefined,
  decujusId?: string,
): boolean {
  const hid = p.herdeiroId?.toString() || '';
  if (!hid || !familyMap) return false;
  if (decujusId && hid === decujusId) return false;
  const person = familyMap.get(hid);
  return person != null && !person.esta_vivo;
}

export function filterPartilhasVivas(
  partilhas: PartilhaResultado[],
  familyMap: Map<string, PessoaInventario> | undefined,
  decujusId?: string,
): PartilhaResultado[] {
  return partilhas.filter((p) => !isPartilhaHerdeiroFalecido(p, familyMap, decujusId));
}
